import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import SEO from '../components/seo';
import Footer from '../components/Footer';
import HeaderMain from '../components/HeaderMain';
import HeroSingle from '../components/pages/HeroSingle';
import '../styles/app.scss';

const Register = () => {
    useEffect(() => {
        window.location.replace('https://waiver.roller.app/WeRockTheSpectrumGaithersburg');
    }, []);

    return null;
};
export default Register;
